
import { motion } from "framer-motion";

const MarketStatsSection = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="bg-white/5 rounded-xl p-8 backdrop-blur-sm border border-white/10 hover:bg-white/10 transition-colors duration-300"
    >
      <h2 className="text-3xl md:text-4xl font-bold text-racing-accent mb-6">
        The Future of Sports Gaming
      </h2>
      <div className="space-y-6 text-gray-300">
        {/* Market Stats Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="bg-white/10 rounded-lg p-6 text-center border border-racing-accent/20 hover:border-racing-accent transition-colors"
          >
            <div className="text-3xl font-bold text-racing-accent mb-2">$304M-$361M</div>
            <div className="text-sm text-gray-400">Crypto Sports Games Market Cap</div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-white/10 rounded-lg p-6 text-center border border-racing-accent/20 hover:border-racing-accent transition-colors"
          >
            <div className="text-3xl font-bold text-racing-accent mb-2">77.36%</div>
            <div className="text-sm text-gray-400">GMT Market Dominance</div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            viewport={{ once: true }}
            className="bg-white/10 rounded-lg p-6 text-center border border-racing-accent/20 hover:border-racing-accent transition-colors"
          >
            <div className="text-3xl font-bold text-racing-accent mb-2">$1.93B</div>
            <div className="text-sm text-gray-400">Sports Crypto Sector Value</div>
          </motion.div>
        </div>

        {/* Market Share Visualization */}
        <div className="bg-white/5 rounded-lg p-6 border border-white/10">
          <h3 className="text-xl font-semibold mb-4 text-racing-accent">Market Share Distribution</h3>
          <div className="flex items-center gap-4 mb-4">
            <div className="flex-grow h-8 bg-white/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "77.36%" }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: true }}
                className="h-full bg-racing-accent"
              />
            </div>
            <span className="text-sm whitespace-nowrap">GMT 77.36%</span>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex-grow h-8 bg-white/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "13.31%" }}
                transition={{ duration: 1, delay: 0.7 }}
                viewport={{ once: true }}
                className="h-full bg-racing-accent/60"
              />
            </div>
            <span className="text-sm whitespace-nowrap">$CROWN 13.31%</span>
          </div>
        </div>

        {/* Growth Potential Callout */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.9 }}
          viewport={{ once: true }}
          className="bg-racing-accent/20 rounded-lg p-6 border border-racing-accent/30"
        >
          <h3 className="text-xl font-semibold text-center">
            With the broader sports crypto sector valued at $1.93 billion, 
            the growth potential for <b>Front Runner: Racehorse Manager</b> is massive
          </h3>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default MarketStatsSection;
